import { NO_LABEL } from '../constants';

export const isNonValidLabel = (label) => [
  'Punto condiviso',
  '-',
  NO_LABEL,
].includes(label);

export const getName = (item, isRecentList = false) => {
  if (isRecentList) {
    return `${item.street}${item.number ? ` ${item.number}` : ''}`;
  }
  return item.customName || `${item.street}${item.number ? ` ${item.number}` : ''}`;
};

export const getDetails = (item, isRecentList = false) => {
  if (isRecentList) {
    return item.town;
  }
  return item.customName
    ? `${item.street}${item.number ? ` ${item.number}` : ''}, ${item.town}`
    : item.town;
};